import {
    AssignmentApi,
    type AssignmentResponseType,
    type EstimationRouteType,
} from './AssignmentApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { deliveryList, planning, scenarioManager } from '../../../stores/store';
import { AssignmentManager } from './PageScenario/AssignmentManager';
import { calculateRoute2 } from '../../../../test/shared/calculateRoute2';
import { Api } from '@automapa/svelte-automapa-template';
import type { Assignment } from './Assignment';

export class AssignmentBulkActions {
    public static async calculateRoute2(
        api: Api,
        assId: number,
        scenarioId: number | null,
        onUpdate: (assR: AssignmentResponseType) => void = () => {}
    ): Promise<string[]> {
        let errors: string[] = [];
        if (scenarioId === null) {
            console.error('No current scenario id', assId, scenarioId);
            return ['No current scenario id'];
        }

        await calculateRoute2(
            api,
            scenarioId,
            assId,
            null,
            0,
            (assR: AssignmentResponseType) => {}
        ).catch(err => errors.push(err));
        if (typeof onUpdate === 'function') {
            let assR = await AssignmentApi.getOne(api, assId);
            onUpdate(assR);
        }
        return errors;
    }

    public static async lockAssignment(assId: number) {
        let errors: string[] = [];
        await AssignmentApi.setLocked(get(api), assId, true).catch(err => errors.push(err));
        let data = await AssignmentApi.getOne(get(api), assId).catch(err => errors.push(err));
        if (data && typeof data !== 'number') {
            get(scenarioManager).updateAssignment(data);
            scenarioManager.set(get(scenarioManager));
        }
        return errors;
    }

    public static async lockAssignment2(
        api: Api,
        assId: number,
        scenarioManager: AssignmentManager,
        forceDownload: boolean = false
    ) {
        let errors: string[] = [];
        await AssignmentApi.setLocked(api, assId, true, forceDownload).catch(err =>
            errors.push(err)
        );
        let data = await AssignmentApi.getOne(api, assId).catch(err => errors.push(err));
        if (data && typeof data !== 'number') {
            scenarioManager.updateAssignment(data);
            scenarioManager = scenarioManager;
        }
        return errors;
    }

    public static async confirmAssignment3(
        api: Api,
        ass: Assignment,
        selectedDay: string,
        allJobIds: number[],
        waitForEstimates: boolean = true,
        onFinish: (
            assR: AssignmentResponseType,
            unsetR: AssignmentResponseType | null
        ) => void = () => {}
    ) {
        let times = [(new Date()).getTime()];
        let errors: string[] = [];
        await AssignmentApi.confirmAllJobs(api, ass.getId(), selectedDay).catch(err =>
            errors.push(err)
        );
        times.push((new Date()).getTime());
        let estimate: EstimationRouteType | null = null;
        let estimateAlternative: EstimationRouteType | null = null
        if (ass && ass.getId() > 0 && ass.hasVehicleAssigned()) {
            if (waitForEstimates) {
                estimate = (await AssignmentApi.getEstimation(
                    api,
                    ass.getId()
                ).catch(err => errors.push(err))) as EstimationRouteType;
                times.push((new Date()).getTime());
                estimateAlternative = (await AssignmentApi.getEstimation(
                    api,
                    ass.getId(),
                    true,
                    ass.hasRouteBeenEverDownloaded(),
                    allJobIds
                ).catch(err => errors.push(err))) as EstimationRouteType;
            }
            times.push((new Date()).getTime());
        }
        /* only suggestions are assigned, so there is no need to update unassigned
        let unsetR = await AssignmentApi.getUnassignedAsList(api, selectedDay, []).catch(err =>
            errors.push(err)
        );
        */
        let unsetR = null;
        times.push((new Date()).getTime());
        // if (unsetR && typeof unsetR !== 'number') {
        //
        //     scenarioManager.updateAssignment(unset);
        //     scenarioManager = scenarioManager;
        // }
        // let data = await AssignmentApi.getOne(api, ass.getId()).catch(err => errors.push(err));
        // if (data && typeof data !== 'number') {
        //     scenarioManager.updateAssignment(data);
        //     scenarioManager = scenarioManager;
        // }
        let assR = await AssignmentApi.getOne(api, ass.getId());
        ass.set(assR);
        times.push((new Date()).getTime());

        if (waitForEstimates) {
            if (estimate) {
                // console.log('$rsa, AssignmentBulkActions, estimate', estimate);
                ass.setEstimation(estimate);
            }
            if (estimateAlternative && ass) {
                ass.setEstimationAlternative(estimateAlternative);
            }
        } else {
            AssignmentApi.getEstimation(
                api,
                ass.getId()
            ).then((estimate) => {
                if (estimate) {
                    // console.log('$rsa, AssignmentBulkActions, estimate', estimate);
                    ass.setEstimation(estimate);
                    onFinish(ass.get(), null);
                    console.log('??? assign times, estimate');
                    AssignmentApi.getEstimation(
                        api,
                        ass.getId(),
                        true,
                        ass.hasRouteBeenEverDownloaded(),
                        allJobIds
                    ).then((estimateAlternative) => {
                        if (estimateAlternative && ass) {
                            ass.setEstimationAlternative(estimateAlternative);
                        }
                    });
                }
            });
        }
        times.push((new Date()).getTime());
        if (unsetR && typeof unsetR !== 'number') {
            onFinish(ass.get(), unsetR);
        } else {
            onFinish(ass.get(), null);
        }
        times.push((new Date()).getTime());
        times = times.map((v, i) => i == 0 ? 0 : times[i] - times[i-1]);
        console.log('??? assign times', times);
        return errors;
    }
}
